import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';

// Pixel-art Dino with Party Hat - matches Timer/Loader dino
// Values: 0=empty, 1=dino, 2=gold hat, 3=white eye
const CelebrationDino = ({ frame }) => {
  const pixels1 = [
    [0,0,0,0,0,0,0,0,2,0,0,0,0,0],
    [0,0,0,0,0,0,0,2,2,2,0,0,0,0],
    [0,0,0,0,0,0,2,2,2,2,2,0,0,0],
    [0,0,0,0,0,0,1,1,1,1,1,1,0,0],
    [0,0,0,0,0,1,1,1,1,1,1,1,1,0],
    [0,0,0,0,0,1,1,3,1,1,1,1,1,0],
    [0,0,0,0,0,1,1,1,1,1,1,1,0,0],
    [0,0,0,0,0,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0,0,0],
    [0,0,0,1,1,0,1,1,0,0,0,0,0,0],
    [0,0,0,1,0,0,0,1,0,0,0,0,0,0],
    [0,0,0,1,1,0,0,0,0,0,0,0,0,0],
  ];
  
  const pixels2 = [
    [0,0,0,0,0,0,0,0,2,0,0,0,0,0],
    [0,0,0,0,0,0,0,2,2,2,0,0,0,0],
    [0,0,0,0,0,0,2,2,2,2,2,0,0,0],
    [0,0,0,0,0,0,1,1,1,1,1,1,0,0],
    [0,0,0,0,0,1,1,1,1,1,1,1,1,0],
    [0,0,0,0,0,1,1,3,1,1,1,1,1,0],
    [0,0,0,0,0,1,1,1,1,1,1,1,0,0],
    [0,0,0,0,0,1,1,1,1,0,0,0,0,0],
    [0,0,0,1,0,1,1,1,1,1,0,0,0,0],
    [0,0,1,1,1,1,1,1,1,1,0,0,0,0],
    [0,1,1,1,1,1,1,1,1,0,0,0,0,0],
    [1,1,1,1,1,1,1,1,0,0,0,0,0,0],
    [0,1,1,1,1,1,1,1,0,0,0,0,0,0],
    [0,0,1,1,1,1,1,0,0,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0,0,0],
    [0,0,0,1,0,1,0,0,0,0,0,0,0,0],
    [0,0,1,1,0,1,1,0,0,0,0,0,0,0],
  ];
  
  const pixels = frame === 0 ? pixels1 : pixels2;
  const colors = { 1: '#00E5CC', 2: '#FFD700', 3: '#FFFFFF' };
  
  return (
    <div className="relative" style={{ width: '56px', height: '68px' }}>
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel > 0 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: colors[pixel],
              }}
            />
          )
        )
      )}
      {/* Hat pom-pom */}
      <div 
        className="absolute rounded-full"
        style={{
          left: '30px',
          top: '-2px',
          width: '8px',
          height: '8px',
          backgroundColor: '#FF6B6B',
        }}
      />
    </div>
  );
};

// Pixel-art Llama with Party Hat - matches Timer/Loader llama
const CelebrationLlama = ({ frame }) => {
  const pixels = [
    // Party hat (rows -3 to -1)
    [0,0,0,0,3,0,0,0],  // hat tip
    [0,0,0,3,3,3,0,0],  // hat middle
    [0,0,3,3,3,3,3,0],  // hat base
    // Llama ears and body
    [0,0,0,1,0,1,0,0],
    [0,0,0,1,1,1,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,0,0,1,0,0,0],
    [0,0,1,1,1,1,0,0],
    [0,1,1,1,1,1,1,0],
    [0,1,1,1,1,1,1,0],
    [0,0,1,1,1,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
    [0,0,1,0,0,1,0,0],
  ];
  
  const colors = { 1: '#7C3AED', 3: '#8B5CF6' }; // Purple body, Violet hat
  
  return (
    <div className="relative" style={{ width: '32px', height: '60px' }}>
      {pixels.map((row, y) => 
        row.map((pixel, x) => 
          pixel > 0 && (
            <div
              key={`${x}-${y}`}
              className="absolute"
              style={{
                left: `${x * 4}px`,
                top: `${y * 4}px`,
                width: '4px',
                height: '4px',
                backgroundColor: colors[pixel],
              }}
            />
          )
        )
      )}
      {/* Hat pom-pom */}
      <div 
        className="absolute rounded-full"
        style={{
          left: '14px',
          top: '-2px',
          width: '6px',
          height: '6px',
          backgroundColor: '#00E5CC',
        }}
      />
    </div>
  );
};

/**
 * CelebrationPopup - Shows dancing pixel-art dino & llama with confetti
 * Displays when user achieves a streak milestone or completes daily goal
 */
export const CelebrationPopup = ({ 
  isOpen, 
  onClose, 
  type = 'goal', // 'goal' | 'streak'
  value = 1,
  isSpanish = false 
}) => {
  const [animationPhase, setAnimationPhase] = useState(0);
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    if (isOpen) {
      // Trigger confetti
      const duration = 3000;
      const end = Date.now() + duration;

      const colors = ['#00E5CC', '#8B5CF6', '#FFD700', '#FF6B6B', '#4ADE80'];

      (function confettiFrame() {
        confetti({
          particleCount: 3,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: colors
        });
        confetti({
          particleCount: 3,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: colors
        });

        if (Date.now() < end) {
          requestAnimationFrame(confettiFrame);
        }
      }());

      // Animation phases for dancing
      const danceInterval = setInterval(() => {
        setAnimationPhase(prev => (prev + 1) % 4);
      }, 300);

      // Sprite frame animation
      const frameInterval = setInterval(() => {
        setFrame(prev => (prev + 1) % 2);
      }, 200);

      // Auto-close after 5 seconds
      const timeout = setTimeout(() => {
        onClose();
      }, 5000);

      return () => {
        clearInterval(danceInterval);
        clearInterval(frameInterval);
        clearTimeout(timeout);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  // Check if streak is a milestone
  const milestones = [7, 14, 21, 30, 60, 100, 365];
  const isMilestone = type === 'streak' && milestones.includes(value);
  
  // Get milestone badge emoji
  const getMilestoneBadge = () => {
    switch(value) {
      case 7: return '🔥';
      case 14: return '🌟';
      case 21: return '🏅';
      case 30: return '⭐';
      case 60: return '🌙';
      case 100: return '💯';
      case 365: return '🏆';
      default: return '🔥';
    }
  };

  const getMessage = () => {
    if (type === 'goal') {
      return isSpanish 
        ? '¡Meta Diaria Completada!' 
        : 'Daily Goal Complete!';
    } else {
      if (value === 1) {
        return isSpanish ? '¡Racha Iniciada!' : 'Streak Started!';
      }
      if (isMilestone) {
        return isSpanish 
          ? `¡Increíble! ¡${value} Días!` 
          : `Amazing! ${value} Days!`;
      }
      return isSpanish 
        ? `¡Racha de ${value} Días!` 
        : `${value} Day Streak!`;
    }
  };

  const getSubMessage = () => {
    if (type === 'goal') {
      return isSpanish 
        ? '¡Sigue así! Estás haciendo un gran trabajo.' 
        : "Keep it up! You're doing amazing!";
    } else if (isMilestone) {
      return isSpanish 
        ? `¡Desbloqueaste la insignia de ${value} días! ${getMilestoneBadge()}` 
        : `You unlocked the ${value}-day badge! ${getMilestoneBadge()}`;
    } else {
      return isSpanish 
        ? '¡Vuelve mañana para mantener tu racha!' 
        : 'Come back tomorrow to keep your streak going!';
    }
  };

  // Dancing animation transforms
  const getDanceTransform = (character) => {
    const transforms = [
      'translateY(0px) rotate(0deg)',
      'translateY(-8px) rotate(-3deg)',
      'translateY(0px) rotate(0deg)',
      'translateY(-8px) rotate(3deg)'
    ];
    const offset = character === 'llama' ? 2 : 0;
    return transforms[(animationPhase + offset) % 4];
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="relative bg-gradient-to-br from-[#1a1a2e] to-[#2d2d44] rounded-3xl p-8 mx-4 max-w-sm w-full shadow-2xl border border-[#00E5CC]/30 animate-in zoom-in-95 duration-300">
        {/* Close button */}
        <button 
          onClick={onClose}
          className="absolute top-3 right-3 text-muted-foreground hover:text-white transition-colors"
          data-testid="celebration-close-btn"
        >
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Dancing Characters - properly spaced */}
        <div className="flex justify-center items-end gap-6 mb-6">
          {/* Dancing Dino with party hat */}
          <div 
            className="transition-transform duration-200"
            style={{ transform: getDanceTransform('dino') }}
          >
            <CelebrationDino frame={frame} />
          </div>

          {/* Trophy/Star in middle */}
          <div className="animate-pulse mx-2">
            {type === 'goal' ? (
              <div className="text-5xl">🎯</div>
            ) : isMilestone ? (
              <div className="text-5xl">{getMilestoneBadge()}</div>
            ) : (
              <div className="text-5xl">🔥</div>
            )}
          </div>

          {/* Dancing Llama with party hat */}
          <div 
            className="transition-transform duration-200"
            style={{ transform: getDanceTransform('llama') }}
          >
            <CelebrationLlama frame={frame} />
          </div>
        </div>

        {/* Message */}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-white mb-2">
            {getMessage()}
          </h2>
          <p className="text-muted-foreground mb-6">
            {getSubMessage()}
          </p>

          {/* Value display */}
          {type === 'streak' && value > 1 && (
            <div className="flex items-center justify-center gap-2 mb-6">
              <span className="text-4xl font-bold text-[#00E5CC]">{value}</span>
              <span className="text-lg text-muted-foreground">
                {isSpanish ? 'días seguidos' : 'days in a row'}
              </span>
            </div>
          )}

          {/* Continue button */}
          <button
            onClick={onClose}
            className="w-full py-3 px-6 bg-gradient-to-r from-[#00E5CC] to-[#8B5CF6] text-[#0d1f2d] font-semibold rounded-xl hover:opacity-90 transition-opacity"
            data-testid="celebration-continue-btn"
          >
            {isSpanish ? '¡Continuar!' : 'Keep Going!'}
          </button>
        </div>

        {/* Decorative stars */}
        <div className="absolute top-4 left-4 text-2xl animate-bounce">⭐</div>
        <div className="absolute top-8 right-8 text-xl animate-bounce delay-100">✨</div>
        <div className="absolute bottom-12 left-6 text-lg animate-bounce delay-200">🌟</div>
      </div>
    </div>
  );
};

export default CelebrationPopup;
